import { Component, Input, OnDestroy } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-copy-to-clipboard-button',
  templateUrl: './copy-to-clipboard-button.component.html',
})
export class CopyToClipboardButtonComponent implements OnDestroy {
  @Input() values: string[] = [];
  @Input() timeoutDuration: number | null = 1500;

  isCopied = false;
  private copyTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(private clipboardService: ClipboardService) {}

  clipboardCopy(): void {
    if (!this.values || this.values.length === 0) {
      return;
    }

    const textToCopy = this.values.join(',');
    this.clipboardService.copy(textToCopy);
    this.isCopied = true;

    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout);
      this.copyTimeout = null;
    }

    if (this.timeoutDuration != null && this.timeoutDuration > 0) {
      this.copyTimeout = setTimeout(() => {
        this.isCopied = false;
        this.copyTimeout = null;
      }, this.timeoutDuration);
    }
  }

  ngOnDestroy(): void {
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout);
      this.copyTimeout = null;
    }
  }
}

